<template>
    <div id="fund-destinations">
        <section class="section" :class="needsPadding ? 'section-padding' : ''">
            <div class="container">
                <div class="section-heading heading-left mb-0">
                    <!-- WEB -->
                    <div class="row">
                        <div class="col-lg-12 mb--30">
                            <span class="subtitle primary">
                                Uso del crédito.
                            </span>
                            <h2 class="font-weight-100 text-wrap-balance">
                                ¿Para qué lo podrías <span class="bold">utilizar</span>?
                            </h2>
                        </div>
                        <div class="col-lg-12">
                            <div class="row web-destinations">
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="100">
                                    <ImageCard 
                                        title="Educación." 
                                        :avatar="null"
                                        :isBanner="true"
                                        :list="['Colegiaturas.', 'Materiales educativos.']"
                                        bgImg="education" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="200">
                                    <ImageCard 
                                        :avatar="null"
                                        :isBanner="true"
                                        title="Estrés financiero." 
                                        :list="['Consolidación y reestructura de deudas.', 'Imprevistos.']"
                                        bgImg="money" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="300">
                                    <ImageCard 
                                        :avatar="null"
                                        :isBanner="true"
                                        title="Micronegocio." 
                                        :list="['Equipamiento del negocio.', 'Remodelación del inmueble.']"
                                        bgImg="store" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="400">
                                    <ImageCard 
                                        :avatar="null"
                                        :isBanner="true"
                                        title="Vivienda." 
                                        :list="['Equipamiento del hogar.', 'Remodelación del inmueble.']" 
                                        bgImg="home" />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up"
                                    data-sal-duration="1000" data-sal-delay="500">
                                    <ImageCard 
                                        :avatar="null"
                                        :isBanner="true"
                                        title="Salud." 
                                        :list="['Procedimientos médicos.', 'Consultas y medicamentos.']" 
                                        bgImg="health" />
                                </div>
                            </div>
                            <!-- MOBILE -->
                            <div class="mobile-destinations">
                                <slick :options="slickOptions">
                                    <div class="col-12">
                                        <ImageCard 
                                            title="Educación." 
                                            :avatar="null"
                                        :isBanner="true"
                                            :list="['Colegiaturas.', 'Materiales educativos.']"
                                            bgImg="education" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard 
                                            title="Estrés financiero." 
                                            :avatar="null"
                                        :isBanner="true"
                                            :list="['Consolidación y reestructura de deudas.', 'Imprevistos.']"
                                            bgImg="money" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard 
                                            title="Micronegocio." 
                                            :avatar="null"
                                        :isBanner="true"
                                            :list="['Equipamiento del negocio.', 'Remodelación del inmueble.']"
                                            bgImg="store" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard 
                                        title="Vivienda." 
                                        :avatar="null"
                                        :isBanner="true"
                                        :list="['Equipamiento del hogar.', 'Remodelación del inmueble']"
                                         bgImg="home" />
                                    </div>
                                    <div class="col-12">
                                        <ImageCard 
                                        title="Salud." 
                                        :avatar="null"
                                        :isBanner="true"
                                        :list="['Procedimientos médicos', 'Consultas y medicamentos']" 
                                        bgImg="health" />
                                    </div>
                                </slick>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ImageCard from '../partials/image-card.vue';
import Slick from 'vue-slick';
export default {
    name: "FundDestinations",
    props: ["needsPadding"],
    components: {
        ImageCard,
        Slick
    },
    data() {
        return {
            slickOptions: {
                infinite: true,
                autoplay: true,
                arrows: false,
                dots: true,
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            },
        }
    }
}

</script>

<style scoped>
.mobile-destinations {
    display: none;
}

.web-destinations {
    display: flex;
}
@media only screen and (max-width: 575px) {
    .mobile-destinations {
        display: block;
    }

    .web-destinations {
        display: none;
    }
}
</style>